module.exports = __webpack_public_path__ + "img/status_failed-01.33df25fe.png";